<!--
 * @Author: guanxiaoyan guanxiaoyan@bjca.org.cn
 * @Deion: 
 * @Date: 2022-09-15 10:17:58
 * @LastEditors: guanxiaoyan guanxiaoyan@bjca.org.cn
 * @LastEditTime: 2022-09-19 15:36:30
 * @FilePath: /ywx-open/vue/src/components/pagination/pagination.vue
-->
<template>
  <div class="pagecom">
    <el-pagination
      :current-page="currentPage"
      :page-sizes="pageSizes"
      :page-size="pageSize"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
export default {
  props: {
    currentPage: {
      type: Number,
      default: () => {},
    },
    pageSizes: {
      type: Array,
      default: () => {},
    },
    pageSize: {
      type: Number,
      default: () => {},
    },
    total: {
      type: Number,
      default: () => {},
    },
  },
  methods: {
    handleSizeChange(val) {
      this.$emit('sizeChange', val);
    },
    handleCurrentChange(val) {
      this.$emit('currentChange', val);
    },
  },
};
</script>
<style lang="less" scoped>
.pagecom {
  margin: 12px 0;
  text-align: center;
}
</style>
